import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';
import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import api from '../assets/api.png';
import asus from '../assets/asus.png';
import bgIMG from '../assets/bgIMG.png';
import bgWhite from '../assets/bgWhite.png';
import bolt from '../assets/bolt.png';
import circle from '../assets/circle.svg';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import email from '../assets/email.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import logopng from '../assets/logo.png';
//import logosvg from '../assets/logo.svg';
import mobile from '../assets/mobile.png';
import mu5 from '../assets/mu5.png';
import nb from '../assets/nb.png';
import node from '../assets/node.png';
import profile from '../assets/profile.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';
import mern from '../assets/mern.png';
import mean from '../assets/mean.png';
import text_porfolio from '../assets/text_porfolio.png';
import text_porfolio2 from '../assets/text_porfolio2.png';
import text_porfolio3 from '../assets/text_porfolio3.png';

export default {
    about01,
    about02,
    about03,
    about04,
    adidas,
    amazon,
    api,
    asus,
    bgIMG,
    bgWhite,
    bolt,
    circle,
    cpp,
    css,
    email,
    figma,
    flutter,
    git,
    graphql,
    html,
    javascript,
    logopng,
    mobile,
    mu5,
    nb,
    node,
    profile,
    python,
    react,
    redux,
    sass,
    skype,
    spotify,
    typescript,
    vue,
    mern,
    mean,
    text_porfolio,
    text_porfolio2,
    text_porfolio3,
};